module.exports = __webpack_public_path__ + "static/media/IMG_8016.9d7f3229.jpg";